<template>
  <div id="app">
    <!-- Navigation Bar Section -->
    <NavigationBar />

    <!-- Main content section with Bootstrap container -->
    <main class="container">
      
      <!-- About Me Section -->
      <section id="about">
        <AboutMe />
      </section>

      <!-- Education Section -->
      <section id="education">
        <EducationDetails />
      </section>

      <!-- Job Experience Section -->
      <section id="experience">
        <JobExperience />
      </section>

      <!-- Technical Skills Section -->
      <section id="skills">
        <TechSkills />
      </section>

      <!-- Interest section -->
      <section id="interests">
        <InterestsSection/>
      </section>
      
      <!-- Contact section -->
      <section id="contact">
        <ContactForm />
      </section>
      
    </main>

    <!-- Site Footer Section -->
    <SiteFooter />
  </div>
</template>

<script>
import NavigationBar from './components/NavigationBar.vue';
import AboutMe from './components/AboutMe.vue';
import EducationDetails from './components/EducationDetails.vue';
import JobExperience from './components/JobExperience.vue';
import TechSkills from './components/TechSkills.vue';
import InterestsSection from './components/InterestsSection.vue'
import ContactForm from './components/ContactForm.vue';
import SiteFooter from './components/SiteFooter.vue';

// Import the theme's CSS
import '@/css/styles.css';

export default {
  name: 'App',
  components: {
    NavigationBar,
    AboutMe,
    EducationDetails,
    JobExperience,
    TechSkills,
    InterestsSection,
    ContactForm,
    SiteFooter,
  },
  mounted() {
    // Initialize theme from localStorage or system preference
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (savedTheme) {
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else if (systemPrefersDark) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
  },
};
</script>

